export default __webpack_public_path__ + "logo-dark.977b48.png";